exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drag-divider[data-v-323cc698] {\n  cursor: col-resize;\n}\n", ""]);

// exports
